export default "__VITE_ASSET__2f6e5ea4__"